import { render, staticRenderFns } from "./class_authorize_book.vue?vue&type=template&id=01130491&scoped=true"
import script from "./class_authorize_book.vue?vue&type=script&lang=ts"
export * from "./class_authorize_book.vue?vue&type=script&lang=ts"
import style0 from "./class_authorize_book.vue?vue&type=style&index=0&id=01130491&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01130491",
  null
  
)

export default component.exports